import { render, staticRenderFns } from "./Tank3D.vue?vue&type=template&id=f977f8d6"
import script from "./Tank3D.vue?vue&type=script&lang=js"
export * from "./Tank3D.vue?vue&type=script&lang=js"
import style0 from "./Tank3D.vue?vue&type=style&index=0&id=f977f8d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports